import { Button, Modal } from "react-bootstrap";

export default function Error({
    errorMessage,
    setErrorMessage }: {
        errorMessage: string,
        setErrorMessage: React.Dispatch<React.SetStateAction<string>>
    }) {
    return (
        <Modal show={errorMessage?.length > 0} onHide={() => { setErrorMessage(""); }}>
            <Modal.Header closeButton>
                <Modal.Title>Error</Modal.Title>
            </Modal.Header>
            <Modal.Body className="bg-danger text-light">{errorMessage}</Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => { setErrorMessage(""); }}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}